import { CommanderThunkAction } from '@mews-commander/types';
import { openModal } from '../app/actions/common';
import { trackEvent } from '../../middleware/createAnalyticsMiddleware';
import { getReservationUrl } from '../../router/selectors';

const APP_NAVBAR_EVENT_CATEGORY = 'AppNavbar';

export const trackAppNavbarEvent = (url: string) =>
    trackEvent({ eventCategory: APP_NAVBAR_EVENT_CATEGORY, eventAction: 'link clicked', eventLabel: url });

export const openReservation = (): CommanderThunkAction => (dispatch, getState) => {
    const url = getReservationUrl(getState(), {});
    dispatch(openModal(url));
};
